import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/memberVisitsSaga";

const UpdateBtns = () => {
  const dispatch = useDispatch();
  const filtersDirty = useSelector((state) => state.memberVisits.filtersDirty);

  return filtersDirty ? (
    <>
      <button
        className="submit override-submit"
        onClick={() => dispatch(actionCreators.updateData())}
      >
        Update
      </button>

      <button
        className="submit reset override-submit"
        onClick={() => dispatch(actionCreators.resetData())}
      >
        Reset
      </button>
    </>
  ) : null;
};

export default UpdateBtns;
